import   axios              from 'axios';

import { API_URLS         } from '../urls';
import { handleError      } from '../../dataTypes/backendServicesManagment/types';

import { ModerationComment                     ,
         ModerationAction                      ,
         BackendResponse_ModerationCommentList ,
         BackendResponse_ModerationResult      } from '../../dataTypes/moderationManagment/types';


// Récupère la liste des commentaires en attente de modération : ceux des vidéos
// du compte, ou tous pour un super-admin (admin-api filtre d'après adminId).
export const getPendingComments = async (adminId: number): Promise<BackendResponse_ModerationCommentList> => {

  const url = `${API_URLS.getPendingComments}?adminId=${adminId}`;

  let result: BackendResponse_ModerationCommentList = {
    code    : 0,
    comment : "",
    payload : [],
  };

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
     {
      const comments: ModerationComment[] = (response.data ?? []).map((c: any) => ({
        id           : c.id ?? 0,
        ownerId      : c.ownerId ?? null,
        author       : c.author ?? "Anonyme",
        videoId      : c.videoId ?? null,
        videoTitle   : c.videoTitle ?? null,
        creator      : c.creator ?? null,
        text         : c.text ?? "",
        creationDate : c.creationDate ? new Date(c.creationDate) : null,
        status       : c.status ?? "pending",
        aiScore      : typeof c.aiScore === 'number' ? c.aiScore : null,
        aiCategories : c.aiCategories && typeof c.aiCategories === 'object' ? c.aiCategories : {},
        aiEngine     : c.aiEngine ?? null,
      }));

      result = {
        code    : 1,
        comment : "Récupération des commentaires en attente réussie.",
        payload : comments,
      };
     }
    else
     {
      result = handleError<ModerationComment[]>(-101, `Erreur lors de la récupération des commentaires : ${response.status}`, []);
     }
   }
  catch (error)
   {
    console.log(error);
    result = handleError<ModerationComment[]>(-102, 'Network error', []);
   }

  return result;
};


// Approuve ou rejette un commentaire.
export const moderateComment = async (
                                       adminId   : number           ,
                                       commentId : number           ,
                                       action    : ModerationAction ,
                                     ): Promise<BackendResponse_ModerationResult> => {

  const url = API_URLS.moderateComment;

  let result: BackendResponse_ModerationResult = {
    code    : 0,
    comment : "",
    payload : { id: commentId, status: "" },
  };

  try
   {
    // adminId : admin-api vérifie que la vidéo est à ce compte (ou qu'il est super-admin).
    const response = await axios.post(url, { adminId, commentId, action });

    if (response.status === 200)
     {
      result = {
        code    : 1,
        comment : action === 'approve' ? "Commentaire approuvé." : "Commentaire rejeté.",
        payload : {
          id     : response.data?.id ?? commentId,
          status : response.data?.status ?? "",
        },
      };
     }
    else
     {
      result = handleError<{ id: number; status: string }>(-101, `Erreur lors de la modération : ${response.status}`, { id: commentId, status: "" });
     }
   }
  catch (error)
   {
    console.log(error);
    result = handleError<{ id: number; status: string }>(-102, 'Network error', { id: commentId, status: "" });
   }

  return result;
};
